import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const Logistics = () => {
  const solutions = ['Fleet Management', 'Route Optimization', 'Warehouse Management', 'Shipment Tracking', 'Inventory Control', 'Last-Mile Delivery'];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Logistics & Transportation Solutions</h1>
          <p>Fleet management, route optimization, and supply chain software</p>
        </div>
      </section>
      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Optimizing Logistics</h2>
            <p>We build logistics software that optimizes routes, manages fleets, and provides real-time tracking. Our solutions help transportation companies reduce costs, improve delivery times, and enhance customer satisfaction.</p>
          </div>
        </div>
      </section>
      <section className="about-expertise">
        <div className="container">
          <div className="section-header"><h2>Logistics Solutions</h2></div>
          <div className="expertise-grid">{solutions.map((s, i) => <div key={i} className="expertise-item">{s}</div>)}</div>
        </div>
      </section>
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Optimize Your Logistics Operations</h2>
            <p>Contact us to discuss your transportation software needs.</p>
            <Link to="/contact"><Button variant="contained" size="large" endIcon={<ArrowForwardIcon />} sx={{ backgroundColor: '#2271b1', color: '#ffffff', fontWeight: '600', padding: '14px 32px', fontSize: '15px', textTransform: 'none', borderRadius: '3px', boxShadow: '0 1px 0 #135e96', '&:hover': { backgroundColor: '#135e96' } }}>Contact Us</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Logistics;
